import React from "react";
import { bool } from "prop-types";

const AdditionalInfo = ({ isAU }) => {
  const mailToUrl = isAU
    ? "au.customersupport@criteriacorp.com"
    : "techsupport@criteriacorp.com";

  const handleOpenHelpCenter = () => {
    const url = isAU
      ? "https://criteriacorp.helpdocs.io/category/qg9ubd74nb-how-to-guides"
      : "https://criteria.helpdocs.io/category/j204q0726l-how-to-guides";

    window.open(url, "_blank");
  };

  return (
    <div className="help-assistant-disclaimer-text">
      <p className="mb-1">
        To explore more help articles, visit the{" "}
        <button
          type="button"
          className="btn-as-link"
          style={{ top: 0 }}
          onClick={handleOpenHelpCenter}
        >
          Help Center.
        </button>
      </p>
      <p className="mb-1">
        If you need additional help, you can email your Support Team at{" "}
        <a
          className="btn-as-link"
          href={`mailto:${mailToUrl}`}
          style={{ top: 0 }}
        >
          {mailToUrl}
        </a>
      </p>
    </div>
  );
};

AdditionalInfo.propTypes = {
  isAU: bool,
};

export default AdditionalInfo;
